import { type CTNDropdownOptionProps } from '@ctn/ui/types/ctn-dropdown';

import { type ILookup } from '@/interfaces/model/generic.interface';
import { type IMaestro } from '@/interfaces/model/maestros.interface';

export const getOptionsMaestro = (maestros: IMaestro[]): CTNDropdownOptionProps[] =>
	maestros.map(({ id, descripcion }) => ({ value: String(id), label: descripcion }));

export const getLookup = <T extends ILookup>(idSelected: string | number, maestros: T[]): T | undefined =>
	maestros.find(({ id }) => Number(idSelected) === id);
